import { NavigationItem } from "../interfaces/NavigationItem";

import navigation from "@/features/data/navigation.json";

export const navigationData: NavigationItem[] = navigation;
